import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { API } from '@const'
import * as utils from '@utils'
import Divider from '@material-ui/core/Divider'

const initialState = {
    input: {
        password: '',
        new_password: '',
        confirmation_new_password: '',
    },
    dialogOpen: false,
}

class UserSettingDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'UserSettingDialog')
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset() {
        this.setState({ input: initialState.input })
    }

    OpenDialog() {
        this.reset()
        this.setState({ dialogOpen: true })
    }

    CloseDialog() {
        this.setState({ dialogOpen: false })
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        type="password"
                        label={this.t('password')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.password}
                        onChange={(event) =>
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    password: event.target.value,
                                },
                            })
                        }
                        margin="dense"
                        fullWidth
                    />
                    <TextField
                        autoFocus
                        type="password"
                        label={this.t('newPassword')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.new_password}
                        onChange={(event) =>
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    new_password: event.target.value,
                                },
                            })
                        }
                        margin="dense"
                        fullWidth
                    />
                    <div className={this.props.classes.passwordFormat}>{this.t('passwordFormatError')}</div>
                    <TextField
                        type="password"
                        label={this.t('confirmationNewPassword')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.confirmation_new_password}
                        onChange={(event) =>
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    confirmation_new_password: event.target.value,
                                },
                            })
                        }
                        margin="dense"
                        fullWidth
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            if (this.state.input.new_password !== this.state.input.confirmation_new_password) {
                                utils.addToast(this.t('notEqual'), 'error')
                                return
                            }
                            if (!utils.passwordFormat(this.state.input.new_password)) {
                                utils.addToast(this.t('passwordFormatError'), 'error')
                                return
                            }
                            utils.apiRequest(
                                'put',
                                API.USER_SELF,
                                {
                                    password: this.state.input.password,
                                    new_password: this.state.input.new_password,
                                },
                                (_data) => {
                                    this.setState({ dialogOpen: false })
                                }
                            )
                        }}
                        color="primary">
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.setState({ dialogOpen: false })} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

UserSettingDialog.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    switchSidebar: PropTypes.func,
    sidebarSwitch: PropTypes.bool,
    onRef: PropTypes.func.isRequired,
}

const styles = (_theme) => {
    return {
        passwordFormat: {
            fontSize: '12px',
            color: '#69131c',
            paddingBottom: '10px',
        },
    }
}

export default hoc(styles)(UserSettingDialog)
